import { render, staticRenderFns } from "./AddDataSourceAzureDataFactory.vue?vue&type=template&id=bd2af800&scoped=true&"
import script from "./AddDataSourceAzureDataFactory.vue?vue&type=script&lang=js&"
export * from "./AddDataSourceAzureDataFactory.vue?vue&type=script&lang=js&"
import style0 from "./AddDataSourceAzureDataFactory.vue?vue&type=style&index=0&id=bd2af800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2af800",
  null
  
)

export default component.exports